
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { useState, useEffect, useRef } from "react";
import dynamic from "next/dynamic";
import Meta from "../../components/Meta";
import useTranslation from "next-translate/useTranslation";
import { NextRouter, useRouter } from "next/router";
import { Route } from "../api/courses";
import { VehicleData } from "../../components/vehicles-list/Vehicles-list";
const Searchbox = dynamic(() => import("../../components/searchbox/Searchbox"));
const MapContainer = dynamic(() => import("../../components/map/MapContainer"));
const Vehicles_list = dynamic(() => import("../../components/vehicles-list/Vehicles-list"));
const Client_form = dynamic(() => import("../../components/user/Client_form"));
const Book = () => {
    const router: NextRouter = useRouter();
    const { t } = useTranslation("book");
    const [courses, setCourses] = useState<Route[]>(null);
    const [vehicleSelectToggle, setVehicleSelectToggle] = useState(false);
    const [vehicleData, setVehicleData] = useState<VehicleData>(null);
    const [mode, setMode] = useState<string>("manual");
    const [course, setCourse] = useState<Route>(null);
    const [distance, setDistance] = useState<number>(0);
    const scollToVehiclesRef = useRef<HTMLDivElement | null>(null);
    const scollToFormRef = useRef<HTMLDivElement | null>(null);
    const scollToClientFormRef = useRef<HTMLDivElement | null>(null);
    useEffect(() => {
        fetchDataAsync();
    }, []);
    // Hides the selected car
    useEffect(() => {
        setVehicleData(null);
    }, [vehicleSelectToggle]);
    const fetchDataAsync = async () => {
        try {
            let res: any = {};
            if (process.env.NODE_ENV === "production") {
                const appDomain = process.env.NEXT_PUBLIC_PROD_DOMAIN;
                res = await fetch(`${appDomain}/api/courses`);
            }
            else {
                const localhostUrl = process.env.NEXT_PUBLIC_LOCALHOST;
                res = await fetch(`${localhostUrl}/api/courses`);
            }
            if (!res.ok) {
                throw new Error("Failed to fetch data from the API!");
            }
            setCourses(await res.json());
        }
        catch (error) {
            console.error(error);
            setCourses(null);
        }
    };
    const scrollToEl = (elementId: string, timeout: number) => {
        setTimeout(() => {
            if (elementId === "vehicles" && scollToVehiclesRef.current) {
                scollToVehiclesRef.current.scrollIntoView();
            }
            else if (elementId === "clientForm") {
                scollToClientFormRef.current.scrollIntoView();
            }
            else if (scollToFormRef.current) {
                scollToFormRef.current.scrollIntoView();
            }
        }, timeout);
    };
    const chooseVehicle = () => {
        scrollToEl("clientForm", 100);
    };
    return (<>
      <Meta title={t("meta.title")} desc={t("meta.desc")} cannonicalSubPath="/book"/>
      <div ref={scollToFormRef}>
        <Searchbox courses={courses} setVehicleSelectToggle={setVehicleSelectToggle} setCourse={setCourse} scrollToEl={scrollToEl} router={router} setMode={setMode}/>
      </div>
      <div className="scroll-mt-[100px]" ref={scollToVehiclesRef}>
        {vehicleSelectToggle && (<div>
            <MapContainer start={course.start} end={course.end} isTwoWay={course.isTwoWay} setDistance={setDistance}/>
            <Vehicles_list selectedCourse={course} setVehicle={setVehicleData} isTwoWay={course?.isTwoWay} mode={mode} distance={distance} chooseVehicle={chooseVehicle}/>
          </div>)}
      </div>
      <div className="scroll-mt-[100px]" ref={scollToClientFormRef}>
        {vehicleData && (<Client_form vehicleData={vehicleData} course={course}/>)}
      </div>
    </>);
};
export default Book;

    async function __Next_Translate__getStaticProps__1947d83db5e__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/book/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1947d83db5e__ as getStaticProps }
  